import React, { useState, useEffect } from 'react';
import '../../styles/tablet/TabletEnv.css';
import { HiWifi, HiBattery100 } from 'react-icons/hi2';
import { GoHome } from 'react-icons/go';
import DesktopWindow from '../DesktopWindow';
import { ProjectDetailContent } from '../apps/ProjectsApp';

const TabletEnvironment = ({ coreApps, extraApps, appContent, windows, openWindow, closeWindow, minimizeWindow, maximizeWindow, focusWindow, bg, projectDetailWindows, openProjectDetail, closeProjectDetail }) => {
  const [time, setTime] = useState('');
  useEffect(() => {
    const update = () => setTime(new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }));
    update();
    const int = setInterval(update, 1000);
    return () => clearInterval(int);
  }, []);

  const gridApps = [...coreApps, ...extraApps];
  const dockApps = coreApps; // Just core apps in dock for tablet
  
  return (
    <div className="ipad-tablet-env" style={{ backgroundImage: `url(${bg})` }}>
      <div className="ipad-status-bar">
        <div className="ipad-time">{time}</div>
        <div className="ipad-status-right">
          <HiWifi size={18} />
          <HiBattery100 size={20} />
        </div>
      </div>

      <div className="ipad-home-screen">
        <div className="ipad-app-grid">
          {gridApps.map(app => (
            <button key={app.id} className="ipad-app-btn" onClick={() => openWindow(app.id)}>
              <div className="ipad-icon" style={{ background: `linear-gradient(135deg, ${app.color}cc, ${app.color})` }}>
                {app.icon}
              </div>
              <span className="ipad-icon-label">{app.title.replace('.app', '')}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="ipad-dock-wrapper">
        <div className="ipad-dock">
          {dockApps.map(app => (
            <button key={app.id} className="ipad-app-btn" onClick={() => openWindow(app.id)}>
              <div className="ipad-icon dock-icon" style={{ background: `linear-gradient(135deg, ${app.color}cc, ${app.color})` }}>
                {app.icon}
              </div>
              <span className={`ipad-dock-indicator ${windows[app.id]?.isOpen ? 'active' : ''}`}></span>
            </button>
          ))}
          <div style={{ width: '1px', height: '32px', background: 'rgba(255,255,255,0.2)', margin: '0 8px' }} />
          <button className="ipad-app-btn" onClick={() => {
            // Close all windows to go to home screen
            Object.keys(windows).forEach(id => closeWindow(id));
            Object.keys(projectDetailWindows).forEach(id => closeProjectDetail(id));
          }}>
            <div className="ipad-icon dock-icon" style={{ background: 'linear-gradient(135deg, #888, #444)' }}>
              <GoHome size={24} color="white" />
            </div>
            <span className="ipad-dock-indicator"></span>
          </button>
        </div>
      </div>

      {/* Render open windows natively but constrained to tablet view */}
      <div className="ipad-window-layer">
          {gridApps.map((app) => {
            const win = windows[app.id];
            if (!win?.isOpen) return null;
            return (
              <DesktopWindow
                key={app.id}
                id={app.id}
                title={app.title}
                defaultWidth={app.defaultWidth}
                defaultHeight={app.defaultHeight}
                isOpen={win.isOpen}
                isMinimized={win.isMinimized}
                isMaximized={win.isMaximized}
                zIndex={win.zIndex}
                onFocus={() => focusWindow(app.id)}
                onClose={() => closeWindow(app.id)}
                onMinimize={() => minimizeWindow(app.id)}
                onMaximize={() => maximizeWindow(app.id)}
                isTablet={true}
              >
                {appContent[app.id]}
              </DesktopWindow>
            );
          })}
          
          {Object.entries(projectDetailWindows).map(([winId, { projectId, title }]) => {
            const win = windows[winId];
            if (!win?.isOpen) return null;
            return (
              <DesktopWindow
                key={winId}
                id={winId}
                title={`${title} - Detail`}
                defaultWidth={820}
                defaultHeight={640}
                isOpen={win.isOpen}
                isMinimized={win.isMinimized}
                isMaximized={win.isMaximized}
                zIndex={win.zIndex}
                onFocus={() => focusWindow(winId)}
                onClose={() => closeProjectDetail(winId)}
                onMinimize={() => minimizeWindow(winId)}
                onMaximize={() => maximizeWindow(winId)}
                isTablet={true}
              >
                <ProjectDetailContent projectId={projectId} />
              </DesktopWindow>
            );
          })}
      </div>
    </div>
  );
};

export default TabletEnvironment;
